import { render, staticRenderFns } from "./template-editor-help-modal.vue?vue&type=template&id=bd8216a2"
import script from "./template-editor-help-modal.vue?vue&type=script&lang=js"
export * from "./template-editor-help-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports